<template>
  <section class="content-header">
    <h1>Gremios por expediente</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="compania">Compañía</label>
              <Dropdown v-model="companyia" inputId="compania"
                :options="companyias" optionLabel="nombre" optionValue="id_companyia"
                filter placeholder="Todas las compañías" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_inicio">Fecha inicio</label>
              <Calendar v-model="fechaInicio" inputId="fecha_inicio"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_fin">Fecha fin</label>
              <Calendar v-model="fechaFin" inputId="fecha_fin"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="estado">Estado</label>
              <Dropdown v-model="estado" inputId="estado"
                :options="estados" optionLabel="nombre" optionValue="valor" class="w-100" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="tipo_fecha">Tipo de fecha</label>
              <Dropdown v-model="tipoFecha" inputId="tipo_fecha"
                :options="tiposFecha" optionLabel="nombre" optionValue="valor" class="w-100" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="trabajos_facturados">Trabajos facturados</label>
              <Dropdown v-model="trabajosFacturados" inputId="trabajos_facturados"
                :options="opcionesFacturados" optionLabel="nombre" optionValue="valor" class="w-100" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="label-vacia">&nbsp;</label>
              <div class="botonera">
                <button class="btn btn-primary" @click="cargarInforme('pdf')" :disabled="generando">
                  <i class="fa" :class="generando === 'pdf' ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
                  Generar PDF
                </button>
                <button class="btn btn-success" @click="cargarInforme('xls')" :disabled="generando">
                  <i class="fa" :class="generando === 'xls' ? 'fa-spinner fa-spin' : 'fa-file-excel-o'"></i>
                  Generar Excel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="FormInforme" method="post" style="display:none"></form>
    <iframe name="iframeInforme" style="display:none"></iframe>
  </section>
</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';

export default {
  components: { Dropdown, Calendar },

  data() {
    const hoy = new Date();
    return {
      companyias: [],
      companyia: '',
      fechaInicio: new Date(hoy.getFullYear(), hoy.getMonth(), 1),
      fechaFin: hoy,
      estado: '0',
      tipoFecha: 'fecha_finaliza_trabajo',
      trabajosFacturados: '',
      generando: false,

      estados: [
        { valor: '0', nombre: 'Todos' },
        { valor: '1', nombre: 'Activos' },
        { valor: '2', nombre: 'Finalizados' },
        { valor: '3', nombre: 'Eliminados' }
      ],
      tiposFecha: [
        { valor: 'fecha_finaliza_trabajo', nombre: 'Fecha de subsanación' },
        { valor: 'fecha_factura', nombre: 'Fecha de facturación' }
      ],
      opcionesFacturados: [
        { valor: '', nombre: 'Todos' },
        { valor: 'SI', nombre: 'Sí' },
        { valor: 'NO', nombre: 'No' }
      ]
    };
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = String(fecha.getDate()).padStart(2, '0');
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      return `${d}/${m}/${fecha.getFullYear()}`;
    },

    async cargarInforme(tipo) {
      // El PDF se abre en pestaña, el Excel se descarga desde el iframe
      const destino = tipo === 'pdf' ? 'VentanaInforme' : 'iframeInforme';
      if (tipo === 'pdf') window.open('', 'VentanaInforme');

      this.generando = tipo;
      try {
        const api = new PwgsApi();

        const html = await api.post('informes/informes_gremios_por_expediente', {
          tipo_respuesta: tipo,
          id_companyia: this.companyia,
          fecha_inicio: this.formatearFecha(this.fechaInicio),
          fecha_fin: this.formatearFecha(this.fechaFin),
          estado: this.estado,
          tipo_fecha: this.tipoFecha,
          trabajos_facturados: this.trabajosFacturados
        });

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const formOrigen = doc.querySelector('#form_informe');
        if (!formOrigen) {
          console.error('La API no devolvió el formulario esperado', html);
          return;
        }

        let direccion = localStorage.getItem('direccion');
        if (direccion == 'null.pwgs.app') direccion = 'pwgs5.local';

        const form = document.getElementById('FormInforme');
        form.innerHTML = '';
        form.target = destino;
        form.action = 'https://' + direccion + formOrigen.getAttribute('action');

        const anyadir = (nombre, valor) => {
          const i = document.createElement('input');
          i.type = 'hidden';
          i.name = nombre;
          i.value = valor;
          form.appendChild(i);
        };

        // Descartamos el input mal nombrado que genera el mapeo del Submit
        formOrigen.querySelectorAll('input').forEach(input => {
          if (!input.name.startsWith('Generar ')) anyadir(input.name, input.value);
        });

        anyadir('Submit', tipo === 'pdf' ? 'Generar PDF' : 'Generar XLS');

        form.submit();
      } finally {
        this.generando = false;
      }
    },

    async cargarCompanyias() {
      const api = new PwgsApi();
      const respuesta = await api.get('informes/informes_gremios_por_expediente');
      const filtros = respuesta.filtros || (respuesta.informes && respuesta.informes.filtros) || [];
      const filtro = filtros.find(f => f.nombre_campo === 'id_companyia');
      this.companyias = filtro ? filtro.valores : [];
    }
  },

  mounted() {
    this.cargarCompanyias();
  }
};
</script>

<style scoped>
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

.w-100 :deep(.p-dropdown),
.w-100 :deep(.p-calendar),
.w-100 :deep(.p-inputtext) {
  width: 100%;
}

.botonera {
  display: flex;
  gap: 8px;
}

.label-vacia {
  display: block;
}
</style>